import { render, staticRenderFns } from "./SystemMessageCall.vue?vue&type=template&id=198bf0bb&scoped=true&"
import script from "./SystemMessageCall.vue?vue&type=script&lang=ts&"
export * from "./SystemMessageCall.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessageCall.vue?vue&type=style&index=0&id=198bf0bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198bf0bb",
  null
  
)

export default component.exports